export default __webpack_public_path__ + "img/877e600d45b9889148d6e11d718e41b2.png";